module.exports = "<div class=\"app-body\">\n\n    <ui-view name=\"content\">\n        \n    </ui-view>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./Client/app/tasks/controllers/enquiries/enquiries.html
// module id = 604
// module chunks = 0